import { VehiclesCount } from './VehiclesCount';

export default VehiclesCount;
